import React from 'react'

export default function Cp() {
   return (
      <p className="d-flex flex-row justify-content-center">
      <span>© 2025</span><span className="sr-only">(current)</span>
    </p>
)
}